import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { func, object, string } from "prop-types";
import { connect } from "react-redux";

import FilterInput from "../../atoms/FilterInput";
import Input from "../../atoms/Input";

import { sortingList as sorts } from "../../utils/constant";
import { staticTexts } from "../../utils/Translate";

import "./sorting-search.m.css";

const SortingSearch = ({ query = {}, lang = "bn", navigateToPage = () => {} }) => {
  const [sort, setSort] = useState(sorts.find(({ sort }) => sort === query.sort)?.[lang] || sorts[0][lang]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  let navigateTimeoutId;

  const onChange = useCallback((e) => {
    const { value = "" } = e.target;
    setSort(value);
  }, []);

  const typeClick = (item) => {
    setSort(item[lang]);
    clearTimeout(navigateTimeoutId);

    navigateTimeoutId = setTimeout(() => {
      setOpen(false);

      query.sort = item.sort;
      const queryString = new URLSearchParams(query).toString();
      navigateToPage(`/search?${queryString}`);
    }, 100);
  };

  const onInputClick = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    const outsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target) && !["svg", "use"].includes(event.target?.tagName)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", outsideClick);

    return () => document.removeEventListener("click", outsideClick);
  }, []);

  return (
    <div styleName="base" ref={ref}>
      <div styleName="sorting">
        <span styleName="sort-text">{staticTexts(lang).sortOrder}</span>
        <FilterInput
          type="text"
          isOpen={open}
          styleName="sort-input"
          id="sort-input"
          onChange={onChange}
          onInputClick={onInputClick}
          onArrowClick={onInputClick}
          lang={lang}
          readOnly={true}
          value={sort}
        />
      </div>

      {open && (
        <div styleName="dropdown">
          <div styleName="types">
            {sorts.map((item, index) => (
              <div styleName="type-name" key={index} onClick={() => typeClick(item)}>
                <label styleName="type-text">{item[lang]}</label>
                <Input
                  type="radio"
                  styleName="type-radio"
                  value={item.sort}
                  checked={sort === item[lang]}
                  name="sort"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

SortingSearch.propTypes = {
  query: object,
  lang: string,
  navigateToPage: func,
};

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

export default memo(connect(null, mapDispatchToProps)(SortingSearch));
